import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import Header from './components/Header';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import AudioPlayerBar from './components/AudioPlayerBar';
import ScrollToTop from './components/ScrollToTop';
import CartFeedback from './components/CartFeedback';

const AcademyPage = lazy(() => import('./pages/AcademyPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));
const Login = lazy(() => import('./pages/LoginPage'));
const PanelPage = lazy(() => import('./pages/panel/PanelPage'));
const ProductPage = lazy(() => import('./pages/ProductPage'));

function Application() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CartProvider>
        <AuthProvider>
          <AudioPlayerProvider>
            <ScrollToTop />
            <Header />

            <main>
              <Suspense fallback={null}>
                <Routes>
                  <Route path="/" element={<HomePage key="all" />} />
                  <Route
                    path="/vinilos"
                    element={<HomePage key="vinyl" initialMediaType="vinyl" />}
                  />
                  <Route
                    path="/cds"
                    element={<HomePage key="cd" initialMediaType="cd" />}
                  />
                  <Route path="/discos/:slug" element={<ProductPage />} />
                  <Route path="/academia" element={<AcademyPage />} />
                  <Route path="/faqs" element={<FaqPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/login" element={<Login />} />

                  <Route element={<PrivateRoute />}>
                    <Route path="/panel" element={<PanelPage />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </main>

            <Footer />
            <AudioPlayerBar />
            <CartFeedback />
          </AudioPlayerProvider>
        </AuthProvider>
      </CartProvider>
    </ThemeProvider>
  );
}

export default Application;
